import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import TweenMax from "gsap"
import {Signals} from "@/Imports";
import Facade from "../Facade";
import ScaleManager from "@/stage/ScaleManager";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import Utils from "@base/utils/Utils";
import Config from "@/config/Config";

export default class PreloaderContainer extends BaseContainer {

    constructor(data) {
        super(data)
        this.init()
    }

    init() {
        const back = new window.PIXI.Graphics()
        back.interactive = true
        back.beginFill(0x000000, 1)
        back.drawRect(0, 0, ScaleManager.currentSizes.total.width, ScaleManager.currentSizes.total.height)
        this.addChild(back)

        this.addMainGraphics();
        window.dispatchEvent(new Event('resize'))
    }

    addMainGraphics() {
        this.progressContainer = new PIXI.Container()
        this.addChild(this.progressContainer)

        const frame = new PIXI.Sprite(PIXI.Texture.from('preloading/preloaderLogo'))
        frame.anchor.set(0.5)
        frame.position.set(0, -140)
        frame.scale.y = 1.5
        frame.scale.x = 1.5
        this.progressContainer.addChild(frame)

        this.loaderScreen = new PIXI.Sprite(PIXI.Texture.from('preloading/preloader'))
        this.loaderScreen.anchor.set(0.5)
        this.loaderScreen.scale.y = 2
        this.loaderScreen.scale.x = 1.75
        this.loaderScreen.position.set(0, 50)
        this.progressContainer.addChild(this.loaderScreen)

        this.progressBarContainer = new PIXI.Container()
        this.progressBarContainer.position.set(-(this.loaderScreen.width / 2), this.loaderScreen.y - 3)
        this.progressContainer.addChild(this.progressBarContainer)

        this.progressBarMask = new window.PIXI.Graphics()
        this.progressBarMask.beginFill(0x170701, 1)
        this.progressBarMask.drawRect(0, 0, this.loaderScreen.width, 400)
        this.progressBarContainer.addChild(this.progressBarMask)
        this.progressBarMask.x = -this.progressBarMask.width //-= this.progressBarMask.width/2
        this.progressBarMask.y += 0
        this.progressBarTop = new PIXI.Sprite(PIXI.Texture.from('preloading/preloaderBar'))
        this.progressBarTop.scale.y = 1.5
        this.progressBarTop.scale.x = 1.75

        this.progressBarContainer.addChild(this.progressBarTop)
        this.progressBarTop.mask = this.progressBarMask

        this.progressContainer.position.set(
            ScaleManager.center.x,
            ScaleManager.center.y + (this.progressContainer.height / 2)
        )

        Signals.loadingProgress.add(this.onPreloaderProgress, this)
        this.onOrientationChanged(Facade.orientation)
    }

    onPreloaderProgress = (progress) => {
        if (progress > 100) {
            progress = 100;
        }
        this.progress = progress
        this.progressBarMask.x = -this.progressBarMask.width + (this.progress * this.progressBarMask.width) / 100
    }

    onOrientationChanged(orientationSymbol) {
        switch (orientationSymbol) {
            case 'Hd':
            case 'Hm':
                //this.loaderScreenAnimation.y = ScaleManager.center.y + 260
                // this.loaderScreenAnimation.scale.set(1)
                break

            case 'Vm':
                //this.loaderScreenAnimation.y = ScaleManager.center.y + 330
                //this.loaderScreenAnimation.scale.set(0.6)
                break
        }
    }

    setRandomPosition(object) {
        object.x = Utils.getRandomInt(object.width, ScaleManager.currentSizes.total.width - object.width)
        object.y = Utils.getRandomInt(-100, ScaleManager.currentSizes.total.width + object.height - 100)
    }

    destroy(options) {
        super.destroy(options)
    }

}